import axiosObj from './config';
import { getFormData, getURLParams } from './all-api-helper';
import moment from 'moment/moment';
import { FILTER_DATE_FORMAT } from 'utils/filter';

export function getSummaryData(params) {
  return axiosObj({
    method: 'GET',
    url: '/c/cost_page/cost_summary/',
    params: getURLParams(params),
  });
}

export function getCloudResourceCost({ params }) {
  return axiosObj({
    method: 'GET',
    url: '/c/cost_page/dimension_daily_cost/',
    params: getURLParams(params),
  });
}

export function getPricingUnits({ params }) {
  return axiosObj({
    method: 'GET',
    url: '/c/cost_page/dimension_daily_cost/',
    params: getURLParams(params),
  });
}

export function setCloudResourceCost({ params, dimension }) {
  return axiosObj({
    method: 'POST',
    url: `/c/cost_page/dimension_daily_cost/?dimension=${dimension}`,
    data: getFormData(params),
  });
}

export function getCloudResourceCostForInventory(payload) {
  return axiosObj({
    method: 'POST',
    url: '/c/cost_page/dimension_daily_cost/?dimension=line_item_resource_id',
    data: payload,
  });
}

export function getDimensionDatForTags({ params }) {
  return axiosObj({
    method: 'GET',
    url: '/c/cost_page/tag_values_granularity/',
    params: getURLParams(params),
  });
}

export function getDimensionDataForLabels({ params }) {
  return axiosObj({
    method: 'GET',
    url: '/c/cost_page/label_values_granularity/',
    params: getURLParams(params),
  });
}

export function getDimensionDataForCostAllocationTag({ params }) {
  return axiosObj({
    method: 'GET',
    url: '/c/cost_page/cost_allocation_tag_values_granularity/',
    params: getURLParams(params),
  });
}

/**
 * Query dimensions using the new bulk forecast API
 * This replaces the old approach of making individual calls per resource
 * @param {Object} payload - API payload with dimensions and filters
 * @returns {Promise} Axios response with dimension data
 */
export function queryDimensions(payload) {
  return axiosObj({
    method: 'POST',
    url: '/svc_gateway/api/search/query/dimensions',
    data: payload,
  });
}

export function getReports() {
  return axiosObj({
    method: 'GET',
    url: '/c/cost_page/reports/?is_hidden=false',
  });
}

export function getReportById(id) {
  return axiosObj({
    method: 'GET',
    url: `/c/cost_page/reports/${id}/`,
  });
}

export function getGlobalReports() {
  return axiosObj({
    method: 'GET',
    url: '/c/cost_page/global_reports/',
  });
}

export function getAllHiddenReport() {
  return axiosObj({
    method: 'GET',
    url: '/c/cost_page/reports/?is_hidden=true',
  });
}

export function getHiddenReport(share_code) {
  return axiosObj({
    method: 'GET',
    url: `/c/cost_page/reports/?is_hidden=true&share_code=${share_code}`,
  });
}

export function shareReports(id, data) {
  return axiosObj({
    method: 'POST',
    url: `/c/cost_page/reports/${id}/send/`,
    data,
  });
}

export function saveReports(data) {
  return axiosObj({
    method: 'POST',
    url: '/c/cost_page/reports/',
    data,
  });
}

export function editReports(data, id) {
  return axiosObj({
    method: 'PATCH',
    url: `/c/cost_page/reports/${id}/`,
    data,
  });
}

export function deleteReports(id) {
  return axiosObj({
    method: 'DELETE',
    url: `/c/cost_page/reports/${id}/`,
  });
}

export function configReports(data) {
  return axiosObj({
    method: 'POST',
    url: '/notification/rest/nops_notifications/',
    data,
  });
}

export function getConfigReports(data) {
  return axiosObj({
    method: 'GET',
    url: '/notification/rest/nops_notifications/',
    data,
  });
}

export function updateConfigReports({ data, id }) {
  return axiosObj({
    method: 'PATCH',
    url: `/notification/rest/nops_notifications/${id}/`,
    data,
  });
}

export function testConfigReports(id) {
  return axiosObj({
    method: 'GET',
    url: `/notification/rest/nops_notifications/${id}/send_test`,
  });
}

export function deleteConfigReports(id) {
  return axiosObj({
    method: 'DELETE',
    url: `/notification/rest/nops_notifications/${id}/`,
  });
}

export function getTargets() {
  return axiosObj({
    method: 'GET',
    url: '/c/cost_page/cost_target/',
  });
}

export function getTargetById(id) {
  return axiosObj({
    method: 'GET',
    url: `/c/cost_page/cost_target/${id}/`,
  });
}

export function saveTargets({ data, id }) {
  let url = '/c/cost_page/cost_target/',
    method = 'POST';

  if (id) {
    url = `/c/cost_page/cost_target/${id}/`;
    method = 'PATCH';
  }

  return axiosObj({
    method,
    url,
    data,
  });
}

export function saveTargetDetail(id) {
  return axiosObj({
    method: 'POST',
    url: `/c/cost_page/cost_target/${id}/create_cost_target_plannings/`,
  });
}

export function uploadCSVTarget({ id, data }) {
  return axiosObj({
    method: 'POST',
    url: `/c/cost_page/cost_target/${id}/upload_csv/`,
    data,
  });
}

export function deleteTargets(id) {
  return axiosObj({
    method: 'DELETE',
    url: `/c/cost_page/cost_target/${id}/`,
  });
}

export function getTargetPlanning(id) {
  return axiosObj({
    method: 'GET',
    url: `/c/cost_page/cost_target_planning/?cost_target=${id}`,
  });
}

export function getTargetPlanningHistory(id) {
  return axiosObj({
    method: 'GET',
    url: `/c/cost_page/cost_target_planning_history/?cost_target=${id}`,
  });
}

export function getDefaultPlanningData(id) {
  return axiosObj({
    method: 'GET',
    url: `/c/cost_page/reports/${id}/get_cost_target_lookback/?start_date=${moment().startOf('M').format(FILTER_DATE_FORMAT)}&period=MONTHLY&lookback_period=3`,
  });
}

export function saveTargetPlanning({ data, id }) {
  let url = '/c/cost_page/cost_target_planning/',
    method = 'POST';

  if (id) {
    url = `/c/cost_page/cost_target_planning/${id}/`;
    method = 'PATCH';
  }

  return axiosObj({
    method,
    url,
    data,
  });
}

export function deleteTargetPlanning(id) {
  return axiosObj({
    method: 'DELETE',
    url: `/c/cost_page/cost_target_planning/${id}/`,
  });
}

export function getPPAProjectServices({ params }) {
  return axiosObj({
    method: 'GET',
    url: '/c/cost_page/dimension_daily_cost/',
    params: getURLParams({
      ...params,
      dimension: 'product_product_name',
      //      bill_billing_entity: [
      //        { type: 'Include', value: 'AWS' },
      //        { type: 'Include', value: 'AWS Marketplace' },
      //      ],
    }),
  });
}

// -----------------------------
// Cost Target Alerts CRUD APIs
// -----------------------------

/**
 * Fetch list of cost target alerts. When `cost_target` is provided, alerts are filtered by that cost target id.
 * @param {Object} params
 * @param {number} [params.cost_target] - Optional cost target id to filter alerts.
 */
export function getCostTargetAlerts({ cost_target } = {}) {
  const params = new URLSearchParams();
  params.append('imply_client', 'true');

  if (cost_target !== undefined) {
    params.append('cost_target', cost_target);
  }

  return axiosObj({
    method: 'GET',
    url: `/c/cost_page/cost_target_alert/?${params.toString()}`,
  });
}

/**
 * Retrieve a single cost target alert by id.
 * @param {number} id Alert id
 */
export function getCostTargetAlertById(id) {
  return axiosObj({
    method: 'GET',
    url: `/c/cost_page/cost_target_alert/${id}/`,
  });
}

/**
 * Create or update a cost target alert.
 * When `id` is supplied we PATCH, otherwise POST to create.
 * @param {Object} params
 * @param {Object} params.data Alert payload
 * @param {number} [params.id] Optional alert id – if provided, will update the alert
 */
export function saveCostTargetAlert({ data, id }) {
  let url = '/c/cost_page/cost_target_alert/',
    method = 'POST';

  if (id) {
    url = `/c/cost_page/cost_target_alert/${id}/`;
    method = 'PATCH';
  }

  return axiosObj({
    method,
    url,
    data,
  });
}

/**
 * Delete a cost target alert by id.
 * @param {number} id Alert id
 */
export function deleteCostTargetAlert(id) {
  return axiosObj({
    method: 'DELETE',
    url: `/c/cost_page/cost_target_alert/${id}/`,
  });
}

export function syncAlertFrequencies(costTargetId) {
  return axiosObj({
    method: 'POST',
    url: `/c/cost_page/cost_target_alert/sync_alert_frequencies/?cost_target_id=${costTargetId}`,
  });
}
